export default "__VITE_ASSET__DLCLaFfo__"